module.exports = __webpack_public_path__ + "img/noaa-logo-horizontal.fe31653c.png";